import type { KeyboardEvent } from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

/**
 * Bấm nút bằng bàn phím: click nổi lên khung ô (rc-input) và khung tự đưa con trỏ về ô nhập.
 * Trả con trỏ lại nút ngay sau đó để người dùng bàn phím nghe được trạng thái mới
 * (aria-pressed) và bấm lại được. Enter tạo click ở keydown, Space ở keyup.
 */
const keepFocusOnToggle = (event: KeyboardEvent<HTMLButtonElement>) => {
  const isEnter = event.type === 'keydown' && event.key === 'Enter';
  const isSpace = event.type === 'keyup' && event.key === ' ';
  if (!isEnter && !isSpace) return;
  const button = event.currentTarget;
  window.setTimeout(() => button.focus(), 0);
};

/**
 * `iconRender` cho <Input.Password>: trả về <button> thật để nút mắt nhận Tab và bật/tắt bằng
 * Space/Enter (biểu tượng mặc định của antd 5.29 là <span> gắn onClick, không nhận Tab).
 * antd clone phần tử này, gắn onClick + className `ant-input-password-icon` (kiểu nằm trong
 * auth-layout.module.scss) và chặn mousedown nên bấm chuột không làm ô mất con trỏ.
 *
 * Nhãn cố định + aria-pressed (mẫu nút bật/tắt chuẩn): trình đọc màn hình đọc
 * "Hiện mật khẩu, nút bật tắt, đã nhấn / chưa nhấn".
 *
 * @example <Input.Password iconRender={passwordIconRender} />
 */
export const passwordIconRender = (visible: boolean) => (
  <button
    type="button"
    aria-label="Hiện mật khẩu"
    aria-pressed={visible}
    onKeyDown={keepFocusOnToggle}
    onKeyUp={keepFocusOnToggle}
  >
    {visible ? <EyeOutlined aria-hidden="true" /> : <EyeInvisibleOutlined aria-hidden="true" />}
  </button>
);

export default passwordIconRender;
